module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/ui/mobile-chat-751f27320fea016544f3c15c4c3e5054.png";